import { Component, OnInit } from '@angular/core';
import { constants } from 'src/app/constants';

@Component({
  selector: 'app-audit-get-session',
  templateUrl: './audit-get-session.component.html',
  styleUrls: ['./audit-get-session.component.css'],
  providers: [
    { provide: Window, useValue: window }
  ]
})
export class AuditGetSessionComponent implements OnInit {

  sessionId: string;

  constructor(public window: Window) {
  }
  
  ngOnInit() {
    //Get the Access token - to be passed to parent window later
    this.sessionId = constants.access_token;

    // Clear access token from Application context
    constants.access_token = "";

    var opener = window.opener; // Reference to window that trigerred the pop-up

    // Send Access token for current phase to parent window through as a postMessage
    // Reference: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
    opener.postMessage({"accessToken": this.sessionId}, "*");

    // Once the SI token has been shared with parent window, trigger auto-close for pop-up
    window.close();
  }

}
